import { Fragment, useEffect, useState } from "react";
import "./CustomEmissionCreation.scss";
import { useTranslation } from "react-i18next";
import { Cascader, Select as AntSelect } from "antd";
import { CaretDownOutlined } from "@ant-design/icons";
import {
  Checkbox,
  Chip,
  CircularProgress,
  Divider,
  FormControl,
  FormControlLabel,
  InputAdornment,
  InputLabel,
  Menu,
  MenuItem,
  Radio,
  RadioGroup,
  Select,
  SelectChangeEvent,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TextField,
} from "@mui/material";
import FileAttachmentsDetails from "../../common/FileAttachmentsDetails";
import AddIcon from "@mui/icons-material/Add";
import {
  UpdateCustomEmissionService,
  getAllCategories,
  getCustomEmissionList,
} from "../../../services/emissionService";
import {
  Navigate,
  useLocation,
  useNavigate,
  useParams,
} from "react-router-dom";
import CreatableSelect from "react-select/creatable";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import CancelIcon from "@mui/icons-material/Cancel";
import React from "react";
import { getAllUomsService } from "../../../services/emissionService";
import {
  getYearFromDate,
  graphRoundOff,
  round,
  toastMessage,
} from "../../../helper";
import { CUSTOM_EMISSION_TYPE } from "../../../constants/enums";
import { fetchBusinessUnit } from "../../../services/orgService";
import { createCustomEmissionFactor } from "../../../services/emissionService";
import { errorMessage } from "../../../constants/messageConstants";
import { isObjectsEqual } from "../../../helper";
const styles = (theme: any) => ({
  ".MuiOutlinedInput-notchedOutline": {
    border: "1px solid #D7DFE9",
    borderRadius: "8px",
    height: "3rem",
  },
  "&:hover": {
    ".MuiOutlinedInput-notchedOutline": {
      border: "2px solid #59CE90 !important",
    },
  },
});
const customStyles = {
  control: (base: any, state: any) => ({
    ...base,
    //width: "20rem",
  }),
};

const tableObject = {
  activityName: "",
  year: "default",
  uom: [],
  factorUom: [],
};
const ValuesToBeRemoved = ["kg CO2e", "kg CO2", "tCO2", "tCO2e"];

const emissionDropDown = [
  {
    name: "Individual Gases",
    selected: true,
  },
  {
    name: "kg CO2e",
    selected: false,
  },
  {
    name: "t CO2e",
    selected: false,
  },
];
const getSymbolValue = (reqFactorUom: any) => {
  if (reqFactorUom.gasesSelected) {
    const uomUnit = reqFactorUom.name.split(" ")[0];
    const uom = reqFactorUom.name.split("/")[1];
    return uomUnit + " " + "CO2/" + uom;
  }
  return reqFactorUom.name;
};

let defaultFactorGasList: any = {};

let defaultUOMFactorList: any = {};

const CustomEmissionCreation = () => {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const { Option } = AntSelect;
  const [showActivityDropDown, setShowActivityDropDown] = useState(false);
  const [categorySelection, setCategorySelection] = useState([] as any);
  const [activityType, setActivityType] = useState([
    { name: "Consumption based", selected: false, id: 1 },
    { name: "Spent based", selected: false, id: 2 },
    { name: "Distance based", selected: false, id: 3 },
    { name: "Volume based", selected: false, id: 4 },
    { name: "Weight based", selected: false, id: 5 },
  ]);
  const [errorData, setErrorData] = useState({
    activityTypeError: "",
  });
  const [selectedActivityType, setSelectedActivityType] = useState([] as any);
  const [tableData, setTableData] = useState([] as any);
  const [activityTableData, setActivityTableData] = useState([] as any);
  const [currentActivityType, setCurrentActivityType] = useState("");
  const [selectedvalue, setSelectedValue] = useState([]);
  const [bunitId, setBunitId] = useState();
  const [companyId, setCompany] = useState();
  const [cellColumns, setCellColumns] = useState([
    "Activity name",
    "Year",
    "UOM",
    "Emission factor",
    "Factor UOM",
    "",
    "",
  ]);
  const [isLoading, setIsLoading] = useState(false);
  const getUomName = (symbol: string) => {
    const parts = symbol?.split("/");
    if (parts?.length > 1) {
      return parts[parts?.length - 1];
    } else {
      return symbol;
    }
  };
  const [uom, setUom] = useState<any>(["GJ", "kg"]);
  const [individualGasList, setIndividualGasList] = useState([
    { name: "CO2", id: 1 },
    { name: "CH4", id: 2 },
    { name: "N2O", id: 3 },
    { name: "SF6", id: 4 },
    { name: "NF3", id: 5 },
  ]);
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const [anchorE2, setAnchorE2] = React.useState<null | HTMLElement>(null);
  const [unitForGas, setUnitForGas] = useState("kg");
  const open = Boolean(anchorEl);
  const open2 = Boolean(anchorE2);
  const [formData, setFormData] = useState<any>({
    categoryName: "",
    categoryCode: "",
    sourceName: "",
    sourceUrl: "",
    activityName: "",
    attachments: [],
    methodUrl: "",
  });
  const [mainIndex, setMainIndex] = useState(0);
  const [subIndex, setSubIndex] = useState(0);
  const [allCustomEmission, setAllCustomEmission] = useState([] as any);
  const { id } = useParams();
  let isEdit = !!id;
  const { state } = useLocation();
  const handleClick = (
    event: React.MouseEvent<HTMLButtonElement>,
    mainIndex: any,
    subIndex: any
  ) => {
    const changed = activityTableData.filter(
      (each: any) => each.activityType === currentActivityType
    )[0];
    const unchanged = activityTableData.filter(
      (each: any) => each.activityType !== currentActivityType
    );
    const reqActivity = JSON.parse(
      JSON.stringify(changed.activities[mainIndex])
    );
    if (reqActivity.factorUom[subIndex][0].gasesSelected) {
      setAnchorE2(event.currentTarget);
    } else {
      setAnchorEl(event.currentTarget);
    }
    setMainIndex(mainIndex);
    setSubIndex(subIndex);
  };
  const handleCategory = (value: string) => {
    const categoryId = categorySelection.filter(
      (each: any) => each.name === value
    )[0];
    setFormData({
      ...formData,
      categoryName: categoryId.id,
      categoryCode: categoryId.code,
    });
  };

  const handleSourceName = (e: any) => {
    setFormData({
      ...formData,
      sourceName: e.target.value,
    });
  };

  const handleSourceUrl = (e: any) => {
    setFormData({
      ...formData,
      sourceUrl: e.target.value,
    });
  };
  const handleMethodUrl = (e: any) => {
    setFormData({
      ...formData,
      methodUrl: e.target.value,
    });
  };
  const handleActivityType = (e: any) => {
    setErrorData({ ...errorData, activityTypeError: "" });
    const tempCategory = formData?.categoryCode;
    const tempSourceName = formData?.sourceName;
    const reqEmission = allCustomEmission
      .find((eachEmission: any) => eachEmission.category_code === tempCategory)
      ?.data.find((each: any) => each.name === "Custom Source");
    const usedMethod = reqEmission?.subtypes.find(
      (each: any) => each.name === tempSourceName
    )?.methods;
    let isDuplicate =
      usedMethod && usedMethod.filter((each: any) => each.name === e).length > 0
        ? true
        : false;
    if (isDuplicate) {
      setErrorData({
        ...errorData,
        activityTypeError: errorMessage().CUSTOM_EMISSION_ERROR,
      });
    } else {
      setCurrentActivityType(e);
      setSelectedActivityType([...selectedActivityType, e]);
      const updatedActivityType = activityType.map((each: any) => {
        if (each.name === e) {
          return {
            ...each,
            selected: true,
          };
        }
        return each;
      });
      setActivityType(updatedActivityType);
      setShowActivityDropDown(false);
    }
  };
  const handleCancel = () => {
    navigate("/datasource/customemissionfactor");
  };
  const handleTableSelection = (activityName: string) => {
    setCurrentActivityType(activityName);
  };
  const handleTableChange = (
    e: any,
    type: string,
    idx: number,
    subId: number,
    gas: any,
    UomName: any
  ) => {
    const tempTableData = activityTableData.filter(
      (eachData: any) => eachData.activityType === currentActivityType
    )[0];
    const unchanged = activityTableData.filter(
      (eachData: any) => eachData.activityType !== currentActivityType
    );
    const tempactivity = tempTableData.activities[idx];
    if (type === CUSTOM_EMISSION_TYPE.UOM) {
      const oldUom = tempactivity[type];
      tempactivity[type] = e;
      if (e.length > oldUom.length) {
        // this is the case for adding a UOM
        const factorUOMlist = e
          .filter((each: any) => !oldUom.includes(each))
          .map((uomId: number) => {
            const reqUom = uom.find((each: any) => each.id === uomId);
            const keyName = reqUom.symbol;
            const to_return = JSON.parse(
              JSON.stringify(defaultUOMFactorList[keyName])
            );
            return to_return;
          });
        tempactivity["factorUom"] = [
          ...tempactivity["factorUom"],
          ...factorUOMlist,
        ];
      } else {
        // this is the case for deletion of UOM
        const deletedUomId = oldUom.filter((each: any) => !e.includes(each))[0];
        const deletedUom = uom.filter(
          (each: any) => each.id === deletedUomId
        )[0].symbol;
        const updatedFactorUom = tempactivity.factorUom.filter(
          (each: any) => each[0].uomName !== deletedUom
        );
        tempactivity["factorUom"] = [...updatedFactorUom];
      }
    } else if (type === CUSTOM_EMISSION_TYPE.FACTOR_UOM) {
      let factorValue = 0;
      let curUnit = "";
      tempactivity.factorUom[subId].forEach((each: any) => {
        if (each.name !== e) {
          factorValue = parseFloat(each.value);
          curUnit = each.name;
        }
      });
      // const newValue = getUOMValue(factorValue, curUnit);
      const newValue = factorValue;
      tempactivity.factorUom[subId].forEach((each: any) => {
        if (each.name === curUnit) {
          each.selected = false;
          each.value = factorValue;
        } else {
          each.selected = true;
          each.value = newValue;
        }
      });
    } else if (type === CUSTOM_EMISSION_TYPE.EMISSION_FACTOR) {
      tempactivity.factorUom[subId].forEach((each: any) => {
        if (
          each.selected &&
          !isNaN(e.target.value) &&
          e.target.value.indexOf(" ") === -1
        ) {
          each.value = e.target.value;
        }
      });
    } else if (type === CUSTOM_EMISSION_TYPE.ACTIVITY_NAME) {
      tempTableData.activities[idx].activityName = e.target.value;
    } else if (type === CUSTOM_EMISSION_TYPE.GASES) {
      // only one gas can come when this event triggers.
      const reqFactorUom = JSON.parse(
        JSON.stringify(tempactivity.factorUom[subId])
      );
      const incomingGas = e.target.value[0];
      const isAddition = !reqFactorUom[0]["gases"].includes(incomingGas);
      if (isAddition) {
        // case when we are adding a new gas.
        reqFactorUom.forEach((each: any) => {
          each.gases.push(incomingGas);
          const temp = JSON.parse(
            JSON.stringify(defaultFactorGasList[incomingGas])
          );
          if (unitForGas === "kg") {
            temp[0].selected = temp[0].name.includes("kg") ? true : false;
            temp[1].selected = !temp[0].selected;
          } else {
            temp[0].selected = temp[0].name.includes("kg") ? false : true;
            temp[1].selected = !temp[0].selected;
          }
          each.factorGases.push(JSON.parse(JSON.stringify(temp)));
        });
        tempactivity.factorUom[subId] = JSON.parse(
          JSON.stringify(reqFactorUom)
        );
      } else {
        // case when we are deleting a old gas.
        const remainingGases = reqFactorUom[0][type].filter(
          (eachGas: any) => eachGas != incomingGas
        );
        reqFactorUom[0]["gases"] = JSON.parse(JSON.stringify(remainingGases));
        reqFactorUom[1]["gases"] = JSON.parse(JSON.stringify(remainingGases));
        const remainingFactorGases = reqFactorUom[0].factorGases.filter(
          (eachFactor: any) => !eachFactor[0].name.includes(incomingGas)
        );
        reqFactorUom[0]["factorGases"] = JSON.parse(
          JSON.stringify(remainingFactorGases)
        );
        reqFactorUom[1]["factorGases"] = JSON.parse(
          JSON.stringify(remainingFactorGases)
        );
        tempactivity.factorUom[subId] = JSON.parse(
          JSON.stringify(reqFactorUom)
        );
      }
    } else if (type === CUSTOM_EMISSION_TYPE.FACTOR_GASES) {
      const unit = e.target.defaultValue;
      setUnitForGas(unit);
      const reqFactorUom = JSON.parse(
        JSON.stringify(
          tempactivity.factorUom.filter(
            (each: any) => each[0].uomName === UomName.uomName
          )[0]
        )
      );
      reqFactorUom.forEach((eachFactor: any) => {
        eachFactor.factorGases.forEach((each: any) => {
          if (unit === "kg") {
            each[0].selected = each[0].name.includes(e.target.defaultValue)
              ? true
              : false;
            each[1].selected = !each[0].selected;
          } else {
            each[0].selected = each[0].name.includes("kg") ? false : true;
            each[1].selected = !each[0].selected;
          }
        });
      });
      const tempFactorUom = tempactivity.factorUom.map((each: any) => {
        if (each[0].uomName === UomName.uomName) {
          return reqFactorUom;
        }
        return each;
      });
      tempactivity.factorUom = JSON.parse(JSON.stringify(tempFactorUom));
    } else if (type === CUSTOM_EMISSION_TYPE.GAS_EMISSION_FACTOR) {
      const reqFactorUom = JSON.parse(
        JSON.stringify(
          tempactivity.factorUom.filter(
            (each: any) => each[0].uomName === UomName.uomName
          )[0]
        )
      );
      reqFactorUom?.forEach((eachFactor: any) => {
        eachFactor.factorGases?.forEach((each: any) => {
          if (each[0].name === gas[0].name) {
            each
              .filter((eG: any) => eG.selected)
              .forEach((eachgas: any) => {
                eachgas.value = e.target.value;
              });
          }
        });
      });
      const tempFactorUom = tempactivity.factorUom.map((each: any) => {
        if (each[0].uomName === UomName.uomName) {
          return reqFactorUom;
        }
        return each;
      });
      tempactivity.factorUom = JSON.parse(JSON.stringify(tempFactorUom));
    } else {
      // this is for text fields
      tempactivity[type] = e.target.value;
    }
    tempTableData.activities[idx] = { ...tempactivity };
    setActivityTableData([...unchanged, tempTableData]);
  };
  const handleAddRow = () => {
    const tempData = activityTableData.filter(
      (each: any) => each.activityType === currentActivityType
    )[0];
    const unChanged = activityTableData.filter(
      (each: any) => each.activityType !== currentActivityType
    );
    const tempActivities = JSON.parse(JSON.stringify(tempData.activities));
    tempActivities.push(tableObject);
    tempData.activities = JSON.parse(JSON.stringify(tempActivities));
    setActivityTableData([...unChanged, tempData]);
  };
  useEffect(() => {
    const reqObj = {
      emissionTarget: true,
      controller: {
        page: 0,
        limit: 100,
      },
    };
    getCustomEmissionList(reqObj).then((res) => {
      const data = res.data;
      setAllCustomEmission(data);
    });
  }, []);

  const handleClose = (name: any) => {
    setAnchorEl(null);
    setAnchorE2(null);
    const mainId: any = mainIndex;
    const index: any = subIndex;
    if (name === "empty") {
      return;
    }
    const changed = activityTableData.filter(
      (each: any) => each.activityType === currentActivityType
    );
    const unChanged = activityTableData.filter(
      (each: any) => each.activityType !== currentActivityType
    );
    const reqActivity = JSON.parse(
      JSON.stringify(changed[0].activities[mainId])
    );
    if (name === "Individual Gases") {
      reqActivity.factorUom[index].forEach((each: any) => {
        each.gasesSelected = true;
        each.emissionDropDown.forEach((eachEmission: any) => {
          if (eachEmission.name === "Individual Gases") {
            eachEmission.selected = false;
          } else {
            eachEmission.selected = true;
          }
        });
      });
    } else {
      if (isKgSelected(reqActivity.factorUom[index][0].name, name)) {
        reqActivity.factorUom[index][0].selected = true;
      } else {
        reqActivity.factorUom[index][0].selected = false;
      }
      reqActivity.factorUom[index][1].selected =
        !reqActivity.factorUom[index][0].selected;
      reqActivity.factorUom[index].forEach((each: any) => {
        each.gasesSelected = false;
        each.emissionDropDown.forEach((eachEmission: any) => {
          if (eachEmission.name === "Individual Gases") {
            eachEmission.selected = true;
          } else {
            eachEmission.selected = false;
          }
        });
      });
    }

    changed[0].activities[mainId] = reqActivity;
    setActivityTableData([...unChanged, changed[0]]);
  };
  const isValidForm = () => {
    return (
      formData?.categoryName &&
      formData?.sourceName &&
      tableData.length &&
      tableData?.filter((each: any) => each.activityName).length ===
        tableData.length &&
      tableData.filter((each: any) => each.uom.length).length ===
        tableData.length
    );
  };
  useEffect(() => {
    getAllUomsService().then((res: any) => {
      res.data.forEach((each: any) => {
        defaultUOMFactorList[each.symbol] = [
          {
            name: `kg CO2e/${getUomName(each.symbol)}`,
            selected: true,
            showIcons: false,
            value: 0,
            uomName: each.symbol,
            gasesSelected: false,
            gases: [],
            factorGases: [],
            emissionDropDown: emissionDropDown,
          },
          {
            name: `t CO2e/${getUomName(each.symbol)}`,
            selected: false,
            showIcons: false,
            value: 0,
            uomName: each.symbol,
            gasesSelected: false,
            gases: [],
            factorGases: [],
            emissionDropDown: emissionDropDown,
          },
        ];
      });
      individualGasList.forEach((each) => {
        defaultFactorGasList[each.name] = [
          {
            name: `kg ${each.name}`,
            selected: true,
            showicons: false,
            value: 0,
            uomName: "",
            gasesSelected: true,
            emissionDropDown: emissionDropDown,
          },
          {
            name: `t ${each.name}`,
            selected: false,
            showicons: false,
            value: 0,
            uomName: "",
            gasesSelected: true,
            emissionDropDown: emissionDropDown,
          },
        ];
      });
      const repeatedValues: any = [];
      res.data.forEach((each: any) => {
        if (!each.symbol.includes("/")) {
          repeatedValues.push(each.symbol);
        }
      });
      const updated = res.data.filter((each: any) => {
        if (!each.symbol.includes("/")) {
          return true;
        }
        const symbol = getUomName(each.symbol);
        if (repeatedValues.includes(symbol)) {
          return false;
        }
        repeatedValues.push(symbol);
        return true;
      });
      setUom(updated);
    });
  }, []);

  useEffect(() => {
    const tempTableData = activityType.map((eachActivity: any) => {
      return {
        activityType: eachActivity.name,
        activities: [{ ...tableObject }],
      };
    });
    setActivityTableData(tempTableData);
    setTableData([...tableData, { ...tableObject }]);
    getAllCategories().then((res: any) => {
      let categorySelection = res.data;
      categorySelection.sort((a: any, b: any) => {
        const codeA = parseFloat(a.code.split(" ")[1]);
        const codeB = parseFloat(b.code.split(" ")[1]);

        return codeA - codeB;
      });
      setCategorySelection(categorySelection);
    });
    setCompany(JSON.parse(localStorage.getItem("company") || "").id);
  }, []);

  useEffect(() => {
    if (Array.isArray(activityTableData)) {
      const reqTableData = activityTableData?.filter(
        (eachData: any) => eachData.activityType === currentActivityType
      );
      if (reqTableData.length && reqTableData[0].activities) {
        setTableData([...reqTableData[0].activities]);
      }
    }
  }, [activityTableData, currentActivityType]);

  const isKgSelected = (tempFactorName: any, uom: any) => {
    const uomUnit = uom.split(" ")[0];
    const kg = tempFactorName.split(" ")[0];
    if (kg === uomUnit) {
      return true;
    }
    return false;
  };

  useEffect(() => {
    if (isEdit) {
      let customEmissionDetails = state.customEmissionDetails;
      setFormData({
        ...formData,
        categoryName: customEmissionDetails.category,
        categoryCode: customEmissionDetails.categorycode,
        sourceName: customEmissionDetails.sourcename,
        sourceUrl: customEmissionDetails.sourcelinkname,
        methodUrl: customEmissionDetails.methodurlname,
        attachments: customEmissionDetails?.attachments?.files,
      });
      setCurrentActivityType(customEmissionDetails.methodname);
      const activityTypes = JSON.parse(
        JSON.stringify(selectedActivityType)
      ).filter((each: any) => each);
      if (!activityTypes.includes(customEmissionDetails.methodname)) {
        setSelectedActivityType([
          ...activityTypes,
          customEmissionDetails.methodname,
        ]);
      }
      const newData = customEmissionDetails.activities.map(
        (eachActivity: any) => {
          let to_return: any = {};
          to_return["activityName"] = eachActivity.activityName;
          to_return["activityId"] = eachActivity.activity;
          to_return["year"] = eachActivity.isDefault
            ? "default"
            : getYearFromDate(eachActivity.fromDate);
          let newUom: any = [];
          let factorUom: any = [];
          eachActivity.uoms.map((eachUom: any) => {
            const eachUomSymbol = eachUom.symbol.split("/")[1];
            const uomId = uom?.filter(
              (each: any) => each.symbol === eachUomSymbol
            )[0]?.id;
            uomId && newUom.push(uomId);
            const tempFactorUom =
              defaultUOMFactorList[eachUomSymbol] &&
              JSON.parse(JSON.stringify(defaultUOMFactorList[eachUomSymbol]));
            const allGases = Object.keys(eachUom.values);
            const unit = eachUom.symbol.split(" ")[0];
            if (tempFactorUom) {
              if (isKgSelected(tempFactorUom[0].name, eachUom.symbol)) {
                tempFactorUom[0].selected = true;
              } else {
                tempFactorUom[0].selected = false;
              }
              if (!eachUom.symbol.includes("CO2e")) {
                setUnitForGas(unit === "kg" ? "kg" : "ton");
                tempFactorUom[0].gasesSelected = true;
                tempFactorUom[1].gasesSelected = true;
                tempFactorUom[0].gases = JSON.parse(JSON.stringify(allGases));
                tempFactorUom[1].gases = JSON.parse(JSON.stringify(allGases));

                allGases.forEach((eachGas: any) => {
                  const tempGasFactor =
                    defaultFactorGasList[eachGas] &&
                    JSON.parse(JSON.stringify(defaultFactorGasList[eachGas]));
                  if (tempGasFactor) {
                    tempGasFactor[0].value = eachUom.values[eachGas];
                    tempGasFactor[1].value = eachUom.values[eachGas];
                    if (unit === tempGasFactor[0].name.split(" ")[0]) {
                      tempGasFactor[0].selected = true;
                    } else {
                      tempGasFactor[0].selected = false;
                    }
                    tempGasFactor[1].selected = !tempGasFactor[0].selected;
                    tempFactorUom[0].factorGases.push(tempGasFactor);
                    tempFactorUom[1].factorGases.push(tempGasFactor);
                  }
                });
              } else {
                tempFactorUom[0].value = eachUom.values.CO2;
                tempFactorUom[1].value = eachUom.values.CO2;
              }
              tempFactorUom[1].selected = !tempFactorUom[0].selected;
            }
            tempFactorUom?.forEach((each: any) => {
              if (each.name === eachUom.symbol) {
                each.selected = true;
                each.value = eachUom.values.CO2;
              }
              each["id"] = eachUom.id;
              each["uomId"] = eachUom.uoms;
            });
            tempFactorUom &&
              factorUom.push(JSON.parse(JSON.stringify(tempFactorUom)));
            tempFactorUom?.forEach((each: any) => {
              if (each.name === eachUom.symbol) {
                each.selected = true;
                each.value = 0;
              }
            });
          });
          to_return["uom"] = newUom;
          to_return["factorUom"] = factorUom;
          to_return["emissionFactor"] = [];
          to_return["factorGases"] = [];
          to_return["gases"] = [];
          return to_return;
        }
      );
      const reqTable = activityTableData.filter(
        (each: any) => each.activityType === customEmissionDetails?.methodname
      )[0];
      const unchanged = JSON.parse(
        JSON.stringify(
          activityTableData.filter(
            (each: any) =>
              each.activityType !== customEmissionDetails?.methodname
          )
        )
      );
      if (reqTable) {
        reqTable.activities = JSON.parse(JSON.stringify(newData));
        setActivityTableData([...unchanged, reqTable]);
      }
    }
  }, [state, uom]);

  const handleDelete = (mainId: number) => {
    const changed = activityTableData.filter(
      (each: any) => each.activityType === currentActivityType
    )[0];
    const unchanged = activityTableData.filter(
      (each: any) => each.activityType !== currentActivityType
    );
    const newActivities = [
      ...changed.activities.slice(0, mainId),
      ...changed.activities.slice(mainId + 1),
    ];
    changed.activities = newActivities;
    setActivityTableData([...unchanged, changed]);
  };

  const handleCreation = () => {
    setIsLoading(true);
    const companyName =
      localStorage.getItem("company") &&
      JSON.parse(localStorage.getItem("company") || "")?.name;
    let reqPayload: any = {
      category: formData.categoryName,
      categoryCode: formData.categoryCode,
      sourceName: formData.sourceName,
      sourceLinkName: formData.sourceUrl,
      methodName: currentActivityType,
      company:
        localStorage.getItem("company") &&
        JSON.parse(localStorage.getItem("company") || "")?.id,
      companyName: companyName,
      attachments: formData.attachments,
      methodURLName: formData.methodUrl,
    };
    const activities = tableData.map((eachRow: any) => {
      const activityName = eachRow.activityName;
      const is_default = eachRow.year === "default" ? true : false;
      const from_date = !is_default && `${eachRow.year}-01-01T00:00:00.000Z`;
      const to_date = !is_default && `${eachRow.year}-12-31T23:59:59.000Z`;
      const totalUoms = eachRow.uom.length;
      const uoms = eachRow.factorUom.map((eachFactor: any) => {
        let result;
        eachFactor
          .filter((each: any) => each.selected)
          .forEach((each: any) => {
            const isGasesSelected = each.gasesSelected;
            if (isGasesSelected) {
              const values: any = {};
              let unitName: any = "";
              each.factorGases.forEach((eachGasFactor: any) => {
                const req = eachGasFactor.filter((e: any) => e.selected)[0];
                const gasName = req.name.substring(req.name.length - 3);
                unitName = req.name.substring(0, req.name.length - 3);
                values[gasName] = req.value;
              });
              result = {
                uomName: `${unitName}CO2/${each.uomName}`,
                values: values,
              };
            } else {
              result = {
                uomName: each.name,
                values: { CO2: parseFloat(each.value) },
              };
            }
          });
        return result;
      });
      return is_default
        ? {
            activityName: activityName,
            isDefault: is_default,
            uoms: uoms,
          }
        : {
            activityName: activityName,
            isDefault: is_default,
            from_date: from_date,
            to_date: to_date,
            uoms: uoms,
          };
    });
    reqPayload["activityData"] = [...activities];
    createCustomEmissionFactor(reqPayload)
      .then((res: any) => {
        navigate("/datasource/customemissionfactor");
        toastMessage("Custom Emission Created Successfully", "success");
      })
      .catch((err) => {
        console.log("error occured in creation: ", err);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  const getYearFromId = (id: any) => {
    return id.split(" ")[0].split("-")[2] === ""
      ? "default"
      : id.split(" ")[0].split("-")[2];
  };

  const handleEdit = () => {
    setIsLoading(true);
    let customEmissionDetails = state.customEmissionDetails;
    const reqCategory = categorySelection.filter(
      (each: any) => each.id === formData.categoryName
    )[0];

    // this is for deletion of UOMs
    const deletedEmissionFactors: any = [];
    customEmissionDetails.activities.forEach((each: any) => {
      const tempreqActivity = tableData.filter(
        // (eachRow: any) => eachRow.year === parseInt(each.id.split(" ")[0].split("-")[2])
        (eachRow: any) =>
          `${eachRow.activityName}-${String(eachRow.year)}` ===
          `${each.activityName}-${getYearFromId(each.id)}`
      );
      const reqActivity = tempreqActivity[0];
      each.uoms.forEach((eachUom: any) => {
        const symbol = eachUom.symbol.split("/")[1];
        const reqId = uom.filter((each: any) => each.symbol === symbol)[0].id;
        if (!reqActivity?.uom?.includes(reqId)) {
          deletedEmissionFactors.push(eachUom.id);
        }
      });
    });
    const updatedFactor: any = [];
    const activitiesList: any = [];
    const newEmissionFactors: any = [];
    const newUoms: any = [];
    tableData.forEach((eachRow: any) => {
      const reqActivity = customEmissionDetails.activities.filter(
        (each: any) =>
          `${eachRow.activityName}-${String(eachRow.year)}` ===
          `${each.activityName}-${getYearFromId(each.id)}`
      )[0];
      const existingIds: any = [];
      const existingUoms: any = [];
      if (!reqActivity) {
        // case for adding a new row
        eachRow.factorUom.forEach((eachFactor: any) => {
          let valueObj: any = {};
          if (eachFactor[0]?.gasesSelected) {
            eachFactor[0]?.factorGases.forEach((eachGas: any[]) => {
              const rg = eachGas.find((each: any) => each.selected) as
                | { name: string; value: number }
                | undefined;
              if (rg) {
                valueObj[rg.name.split(" ")[1] as keyof typeof obj.values] =
                  rg.value;
              }
            });
          } else {
            valueObj["CO2"] = eachFactor.filter(
              (each: any) => each.selected
            )[0].value;
          }
          const obj = {
            uom: undefined,
            symbol: getSymbolValue(
              eachFactor.filter((each: any) => each.selected)[0]
            ),
            values: valueObj,
            local_code: undefined,
            fromDate:
              eachRow.year === "default"
                ? undefined
                : `${eachRow.year}-01-01T00:00:00.000Z`,
            toDate:
              eachRow.year === "default"
                ? undefined
                : `${eachRow.year}-12-31T23:59:59.000Z`,
            isDefault: eachRow.year === "default" ? true : false,
            activityName: eachRow.activityName,
            deleted: undefined,
            id: undefined,
          };
          newEmissionFactors.push(obj);
          newUoms.push(
            getSymbolValue(eachFactor.filter((each: any) => each.selected)[0])
          );
          activitiesList.push(obj.activityName);
        });
      } else {
        reqActivity.uoms.forEach((eachUom: any) => {
          const symbol = eachUom.symbol.split("/")[1];
          const reqId = uom.filter((each: any) => each.symbol === symbol)[0].id;
          existingIds.push(reqId);
          existingUoms.push(eachUom);
        });
        const addedIds: any = [];
        eachRow.uom.forEach((each: any) => {
          if (!existingIds?.includes(each)) {
            addedIds.push(each);
          }
        });
        if (addedIds.length) {
          addedIds.forEach((eachId: any) => {
            const reqUom = existingUoms.filter(
              (each: any) => each.id === eachId
            )[0];
            const reqFactorUom =
              eachRow.factorUom[
                eachRow.uom.findIndex((each: any) => each === eachId)
              ];
            let valueObj: any = {};
            if (reqFactorUom[0]?.gasesSelected) {
              reqFactorUom[0]?.factorGases.forEach((eachGas: any) => {
                const rg = eachGas.find((each: any) => each.selected);
                if (rg) {
                  valueObj[`${rg.name.split(" ")[1]}`] = rg.value;
                }
              });
            } else {
              const { value: reqValue, name: reqSymbol } = reqFactorUom.find(
                (each: any) => each.selected
              );
              const uomUnit = reqSymbol.split("/")[1];
              const reqUom = existingUoms.find(
                (each: any) => each.symbol.split("/")[1] === uomUnit
              );
              valueObj["CO2"] = reqValue;
            }
            const obj = {
              uom: reqUom?.uoms,
              symbol: getSymbolValue(
                reqFactorUom.filter((each: any) => each.selected)[0]
              ),
              values: valueObj,
              local_code: reqUom?.local_code,
              fromDate:
                eachRow.year === "default"
                  ? undefined
                  : `${eachRow.year}-01-01T00:00:00.000Z`,
              toDate:
                eachRow.year === "default"
                  ? undefined
                  : `${eachRow.year}-12-31T23:59:59.000Z`,
              isDefault: eachRow.year === "default" ? true : false,
              activityName: eachRow.activityName,
              activity: reqActivity.activity,
              deleted: false,
              id: reqUom?.id,
            };
            newEmissionFactors.push(obj);
            newUoms.push(obj.symbol);
          });
        } else {
          let isNameUpdated =
            reqActivity.activityName === eachRow.activityName ? false : true;
          let isYearUpdated =
            reqActivity.isDefault && eachRow.year === "default"
              ? false
              : getYearFromDate(reqActivity.fromDate) === eachRow.year
              ? false
              : true;
          eachRow.factorUom.forEach((eachFactor: any) => {
            let isUnitUpdated = false;
            let isFactorUpdated = false;
            const reqFactor = eachFactor.filter(
              (each: any) => each.selected
            )[0];
            let valueObj: any = {};
            const { value: reqValue, name: reqSymbol } = eachFactor.filter(
              (each: any) => each.selected
            )[0];
            let reqUom;
            let tempId;
            let tempUom;
            let tempSymbol;
            if (reqFactor.gasesSelected) {
              let gasUnit = "";
              reqFactor.factorGases.forEach((eachGas: any) => {
                const rg = eachGas.filter((each: any) => each.selected)[0];
                valueObj[`${rg.name.split(" ")[1]}`] = rg.value;
                gasUnit = rg.name.split(" ")[0];
              });
              reqUom = reqActivity.uoms.filter(
                (each: any) => each.symbol.split(" ")[0] === gasUnit
              )[0];
              if (!reqUom) {
                isUnitUpdated = true;
              }
              tempSymbol = gasUnit + " CO2/" + reqFactor.name.split("/")[1];
              isFactorUpdated =
                isUnitUpdated || !isObjectsEqual(reqUom.values, valueObj)
                  ? true
                  : false;
              tempId = reqFactor.id;
              tempUom = reqFactor.uomId;
            } else {
              reqUom = reqActivity.uoms.filter(
                (each: any) => each.symbol === reqSymbol
              )[0];

              const uomUnit = reqSymbol.split("/")[1];
              reqUom = reqActivity.uoms.filter(
                (each: any) => each.symbol.split("/")[1] === uomUnit
              )[0];
              const existingUnit = reqActivity.uoms.filter(
                (each: any) =>
                  each.symbol.split(" ")[0] === reqSymbol.split(" ")[0] &&
                  each.symbol.split("/")[1] === reqSymbol.split("/")[1]
              );
              if (!existingUnit.length) {
                isUnitUpdated = true;
              }
              tempSymbol = reqSymbol;
              isFactorUpdated =
                isUnitUpdated || reqUom.values.CO2 !== Number(reqValue)
                  ? true
                  : false;
              valueObj["CO2"] = reqValue;
              tempId = reqUom?.id;
              tempUom = reqUom?.uoms;
            }
            const obj = {
              uom: tempUom,
              symbol: tempSymbol,
              values: valueObj,
              local_code: reqUom?.local_code,
              fromDate:
                eachRow.year === "default"
                  ? undefined
                  : `${eachRow.year}-01-01T00:00:00.000Z`,
              toDate:
                eachRow.year === "default"
                  ? undefined
                  : `${eachRow.year}-12-31T23:59:59.000Z`,
              isDefault: eachRow.year === "default" ? true : false,
              activityName: eachRow.activityName,
              activity: reqActivity.activity,
              deleted: false,
              id: tempId,
            };
            if (isFactorUpdated || isYearUpdated || isNameUpdated) {
              updatedFactor.push(obj);
            }
            if (isFactorUpdated) {
              newUoms.push(tempSymbol);
            }
          });

          if (isNameUpdated) {
            activitiesList.push(eachRow.activityName);
          }
        }
      }
    });
    const companyName =
      localStorage.getItem("company") &&
      JSON.parse(localStorage.getItem("company") || "")?.name;
    const reqPayload = {
      oldCategory: customEmissionDetails.category,
      oldSubtype: customEmissionDetails.subtype,
      oldSource: customEmissionDetails.source,
      oldSourceLink: customEmissionDetails.sourcelink,
      oldMethodURL: customEmissionDetails.methodurl,
      methodURLName: formData.methodUrl,
      company:
        localStorage.getItem("company") &&
        JSON.parse(localStorage.getItem("company") || "")?.id,
      companyName: companyName,
      category: reqCategory.id,
      categoryname: reqCategory.name,
      categorycode: reqCategory.code,
      type: customEmissionDetails.type,
      typename: customEmissionDetails.typename,
      subtypename: customEmissionDetails.subtypename,
      attachments: formData.attachments,
      method: customEmissionDetails.method,
      methodName: currentActivityType,
      sourceName: formData.sourceName,
      sourceLinkName: formData.sourceUrl,
      deletedEmissionFactors: [...deletedEmissionFactors],
      updatedEmissionFactors: [...updatedFactor],
      activitiesList: [...activitiesList],
      createdEmissionFactors: [...newEmissionFactors],
      uoms: [...newUoms],
    };
    UpdateCustomEmissionService(reqPayload)
      .then((res: any) => {
        navigate("/datasource/customemissionfactor");
        toastMessage("Custom Emission Updated Successfully", "success");
      })
      .catch((err) => {
        console.log("error occured in creation: ", err);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };
  const handleSave = () => {
    if (isEdit) {
      handleEdit();
    } else {
      handleCreation();
    }
  };
  const getCategoryNameAndCode = (catgeoryId: any) => {
    const reqCatgory = categorySelection.filter(
      (each: any) => each.id === catgeoryId
    )[0];
    let categoryName: any;
    if (isEdit) {
      categoryName = reqCatgory?.code + " " + reqCatgory?.name;
    } else {
      if (!reqCatgory) {
        categoryName = undefined;
      } else {
        categoryName = reqCatgory?.code + " " + reqCatgory?.name;
      }
    }
    return categoryName;
  };

  const isGasSelected = (gas: any, factor: any) => {
    if (factor[0].gases.includes(gas.name)) {
      return true;
    }
    return false;
  };
  return (
    <Fragment>
      <div className="pw-activity-data-main w-55v overflow-y-auto bg-neutral-50 flex flex-col ">
        <div className="flex flex-col gap-3">
          <div className="pw-input-label pw-create-label">
            {t("Log Values")}
          </div>
          <div className="flex flex-col gap-2">
            <p className="text-l text-neutral-600 pt-4">{t("Category")}</p>
            <AntSelect
              suffixIcon={
                <CaretDownOutlined className="!pointer-events-none" />
              }
              id="pw-e2e-catdropdown"
              dropdownStyle={{ minWidth: "45%" }}
              style={{ width: "59rem" }}
              className="pw-creation-select pw-account-owner-select"
              placeholder={"Select Category"}
              onChange={handleCategory}
              value={getCategoryNameAndCode(formData.categoryName)}
            >
              {categorySelection.map((each: any, index: number) => (
                <Option value={each.name} id={each.id} key={each.id}>
                  {each.code} {each.name}
                </Option>
              ))}
            </AntSelect>
          </div>
          <div style={{ display: "flex", columnGap: "30px", width: "59rem" }}>
            <div style={{ width: "50%" }} className="">
              <div className="flex flex-row pw-form-field">
                <p className="text-l text-neutral-600 pt-2 pb-2">
                  {t("Source Name")}
                </p>
              </div>
              <TextField
                type="designation"
                variant="outlined"
                placeholder="Source Name"
                size="small"
                name="source name"
                value={formData?.sourceName}
                className="pw-width-100 pw-input-field pw-input-text"
                sx={styles}
                onChange={(e) => {
                  handleSourceName(e);
                }}
              />
            </div>
            <div style={{ width: "50%" }} className="">
              <div className="flex flex-row pw-form-field">
                <div className="text-l text-neutral-600 pt-2 pb-2">
                  {t("Source URL")}
                </div>
              </div>
              <TextField
                type="designation"
                variant="outlined"
                placeholder="Source URL"
                size="small"
                name="designation"
                className="pw-width-100 pw-input-field pw-input-text"
                sx={styles}
                onChange={(e) => {
                  handleSourceUrl(e);
                }}
                value={formData?.sourceUrl}
              ></TextField>
            </div>
          </div>
          <div>
            <FileAttachmentsDetails
              formData={formData}
              setFormData={setFormData}
            />
          </div>
          <div className="flex flex-row items-center gap-5">
            <AntSelect
              suffixIcon={
                <CaretDownOutlined className="!pointer-events-none" />
              }
              dropdownStyle={{ minWidth: "20%" }}
              className="pw-custom-activity"
              placeholder="Select activity type"
              onChange={handleActivityType}
              disabled={!(formData?.categoryCode && formData?.sourceName)}
              value={currentActivityType || undefined}
            >
              {activityType.map((each: any, index: number) => (
                <Option
                  value={each.name}
                  className="pw-menu-item"
                  id={each.name?.replace(/[ .]/g, "")}
                  key={each.id}
                >
                  {each.name}
                </Option>
              ))}
            </AntSelect>
            {errorData.activityTypeError ? (
              <span className="pw-display-error mb-3">
                *{errorData.activityTypeError}
              </span>
            ) : (
              ""
            )}
            {/* <div className="flex flex-row gap-5">
              {!selectedActivityType.length ? (
                <AntSelect
                  suffixIcon={
                    <CaretDownOutlined className="!pointer-events-none" />
                  }
                  //dropdownStyle={{ minWidth: "45%" }}
                  // showSearch
                  className="pw-custom-activity"
                  placeholder="Select activity type"
                  onChange={handleActivityType}
                >
                  {activityType
                    .filter((each: any) => !each.selected)
                    .map((each: any, index: number) => (
                      <Option
                        value={each.name}
                        className="pw-menu-item"
                        id={each.name?.replace(/[ .]/g, "")}
                        key={each.id}
                      >
                        {each.name}
                      </Option>
                    ))}
                </AntSelect>
              ) : (
                selectedActivityType.map((each: any) => {
                  return (
                    <p
                      className={
                        currentActivityType === each
                          ? "text-primary"
                          : "text-neutral-500"
                      }
                      onClick={() => handleTableSelection(each)}
                    >
                      {" "}
                      {each}
                    </p>
                  );
                })
              )}
            </div>
            {!selectedActivityType.length ? (
              <div
                className="flex flex-row  items-center gap-1"
                onClick={() => setShowActivityDropDown(true)}
              >
                <div>
                  <AddIcon className="text-sm text-neutral-500" />
                </div>
                <p className=" text-neutral-500 text-sm">
                  {" "}
                  {t("Activity type")}
                </p>
              </div>
            ) : (
              <AntSelect
                suffixIcon={""}
                value={
                  <div>
                    <AddIcon />
                    {t("Activity type")}
                  </div>
                }
                className="pw-custom-activity"
                placeholder={
                  <div>
                    <AddIcon />
                    {t("Activity type")}
                  </div>
                }
                onChange={handleActivityType}
              >
                {activityType
                  .filter((each: any) => !each.selected)
                  .map((each: any, index: number) => (
                    <Option
                      value={each.name}
                      className="pw-menu-item"
                      key={each.id}
                      id={each.name?.replace(/[ .]/g, "")}
                    >
                      {each.name}
                    </Option>
                  ))}
              </AntSelect>
            )} */}
          </div>
          <div className="flex flex-col bg-white p-2 justify-between gap-2">
            <div className="flex flex-row justify-between">
              <div>
                <TextField
                  type="designation"
                  variant="outlined"
                  placeholder="Activity URL"
                  size="small"
                  name="designation"
                  sx={styles}
                  onChange={(e) => {
                    handleMethodUrl(e);
                  }}
                  value={formData?.methodUrl}
                />
              </div>
              {/* <div className="flex flex-row w-48 items-center">
                <img
                  src="assets/icons/trash-can-outline.svg"
                  className="text-sm p-2"
                />
                <p>Delete activity type</p>
              </div> */}
            </div>
            {selectedActivityType.length ? (
              <div className="text-neutral-600">
                <Table className="pw-custom-emission-table">
                  <TableHead className="bg-neutral-50 pw-custom-table pw-activity-table-head">
                    <TableRow className="text-neutral-600">
                      {cellColumns.map((eachCell, index) => (
                        <TableCell
                          key={index}
                          sx={{ border: "1px solid  #eaeef4" }}
                          className={`pw-activity-list ${
                            index === 5 ? "pw-minor-rows" : "pw-major-rows"
                          }`}
                        >
                          {t(eachCell)}
                        </TableCell>
                      ))}
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {tableData.map((eachRow: any, mainIndex: number) => {
                      return (
                        <TableRow>
                          {/* {this is for activityname} */}
                          <TableCell sx={{ border: "1px solid  #eaeef4" }}>
                            <TextField
                              style={{ width: "15vw" }}
                              className="pw-textfiled-emission pw-e2e-activityname"
                              onChange={(e) =>
                                handleTableChange(
                                  e,
                                  "activityName",
                                  mainIndex,
                                  -1,
                                  {},
                                  ""
                                )
                              }
                              value={eachRow.activityName}
                            />
                            {/* <CreatableSelect
                              // value={formData?.department}
                              styles={customStyles}
                              onChange={(e) =>
                                handleTableChange(
                                  e,
                                  "activityName",
                                  mainIndex,
                                  -1
                                )
                              }
                              onCreateOption={handleActivityCreateOption}
                              onMenuOpen={clearActivityInput}
                              options={activityOptions}
                              placeholder="Activity"
                            /> */}
                          </TableCell>
                          {/* for year */}
                          <TableCell sx={{ border: "1px solid  #eaeef4" }}>
                            <TextField
                              className="pw-textfiled-emission pw-e2e-activityyear"
                              onChange={(e) =>
                                handleTableChange(
                                  e,
                                  "year",
                                  mainIndex,
                                  -1,
                                  {},
                                  ""
                                )
                              }
                              value={eachRow.year}
                            />
                          </TableCell>
                          {/* {for uom} */}
                          <TableCell sx={{ border: "1px solid  #eaeef4" }}>
                            <AntSelect
                              suffixIcon={""}
                              mode="multiple"
                              showSearch
                              onChange={(e) =>
                                handleTableChange(
                                  e,
                                  "uom",
                                  mainIndex,
                                  -1,
                                  {},
                                  ""
                                )
                              }
                              value={eachRow.uom}
                              style={{ width: "10rem" }}
                              className="pw-uom-selection"
                            >
                              {uom
                                ?.filter(
                                  (each: any) =>
                                    !ValuesToBeRemoved.includes(each.symbol)
                                )
                                .map(
                                  ({
                                    symbol,
                                    id,
                                  }: {
                                    symbol: string;
                                    id: number;
                                  }) => (
                                    <Option
                                      key={id}
                                      value={id}
                                      className="pw-menu-item"
                                    >
                                      {getUomName(symbol)}
                                    </Option>
                                  )
                                )}
                            </AntSelect>
                          </TableCell>

                          <TableCell
                            className="pw-e2e-multipleuoms"
                            sx={{ border: "1px solid  #eaeef4" }}
                            colSpan={3}
                          >
                            {eachRow.factorUom.map(
                              (eachUom: any, index: number) => {
                                return eachUom[0]?.gasesSelected ? (
                                  <>
                                    <TableRow>
                                      <TableCell
                                        sx={{
                                          borderRight: "1px solid  #eaeef4",
                                        }}
                                        className="flex justify-between"
                                        style={{
                                          height: "3.5rem",
                                          width: "25rem",
                                        }}
                                        colSpan={2}
                                      >
                                        <FormControl fullWidth size="small">
                                          <InputLabel
                                            shrink={false}
                                            className="!text-neutral-900"
                                          >
                                            {t(
                                              "Individual Gases for " +
                                                eachUom[0].uomName +
                                                "(" +
                                                eachUom[0].gases.length +
                                                " selected)"
                                            )}
                                          </InputLabel>
                                          <Select
                                            value={selectedvalue}
                                            multiple
                                            //label={t("Facility")}
                                            className="pw-individual-gases"
                                            onChange={(e) => {
                                              handleTableChange(
                                                e,
                                                "gases",
                                                mainIndex,
                                                index,
                                                {},
                                                ""
                                              );
                                            }}
                                            renderValue={(p) =>
                                              "Individual Gases for " +
                                              eachUom[0].uomName +
                                              "(" +
                                              eachUom[0].gases.length +
                                              " selected)"
                                            }
                                            style={{
                                              marginLeft: "2rem",
                                            }}
                                          >
                                            <div className="flex flex-row p-2">
                                              <MenuItem>
                                                <RadioGroup
                                                  row
                                                  aria-labelledby="demo-row-radio-buttons-group-label"
                                                  name="row-radio-buttons-group"
                                                  defaultValue={unitForGas}
                                                  onChange={(
                                                    e: React.ChangeEvent<HTMLInputElement>
                                                  ) => {
                                                    handleTableChange(
                                                      e,
                                                      "factorGases",
                                                      mainIndex,
                                                      index,
                                                      {},
                                                      eachUom.filter(
                                                        (each: any) =>
                                                          each.selected
                                                      )[0]
                                                    );
                                                  }}
                                                >
                                                  <FormControlLabel
                                                    value="kg"
                                                    control={<Radio />}
                                                    label="kg"
                                                  />
                                                  <FormControlLabel
                                                    value="ton"
                                                    control={<Radio />}
                                                    label="ton"
                                                  />
                                                </RadioGroup>
                                              </MenuItem>
                                            </div>
                                            <Divider className="!border-neutral-200" />
                                            {individualGasList.map(
                                              (each: any) => (
                                                <MenuItem
                                                  value={each.name}
                                                  key={each.id}
                                                >
                                                  <Checkbox
                                                    className="pw-emission-check"
                                                    checked={isGasSelected(
                                                      each,
                                                      eachUom
                                                    )}
                                                  />
                                                  {each.name}
                                                </MenuItem>
                                              )
                                            )}
                                          </Select>
                                        </FormControl>
                                      </TableCell>
                                      <TableCell
                                        sx={{
                                          borderRight: "1px solid #eaeef4",
                                        }}
                                      >
                                        {
                                          <MoreVertIcon
                                            className="text-neutral-400 pw-ativity-icon"
                                            onClick={(e: any) => {
                                              handleClick(e, mainIndex, index);
                                            }}
                                          />
                                        }
                                        {
                                          <Menu
                                            anchorEl={anchorE2}
                                            open={open2}
                                            onClose={() => handleClose("empty")}
                                          >
                                            <MenuItem
                                              key={id}
                                              onClick={(e) =>
                                                handleClose("kg CO2e")
                                              }
                                              className="pw-e2e-userprofile pw-menu-item"
                                            >
                                              {"kg CO2e"}
                                            </MenuItem>
                                            <MenuItem
                                              key={id}
                                              onClick={(e) =>
                                                handleClose("t CO2e")
                                              }
                                              className="pw-e2e-userprofile pw-menu-item"
                                            >
                                              {"t CO2e"}
                                            </MenuItem>
                                          </Menu>
                                        }
                                      </TableCell>
                                    </TableRow>
                                    {/* this for the individual gas flow */}
                                    {eachUom
                                      .filter((each: any) => each.selected)[0]
                                      .factorGases.map(
                                        (eachGas: any, id: number) => {
                                          return (
                                            <TableRow>
                                              <TableCell
                                                sx={{
                                                  borderRight:
                                                    "1px solid  #eaeef4",
                                                  width: "12.3rem",
                                                }}
                                              >
                                                <TextField
                                                  sx={{
                                                    // width: "12.2rem",
                                                    input: {
                                                      textAlign: "right",
                                                    },
                                                  }}
                                                  className="pw-textfiled-emission"
                                                  inputProps={{
                                                    style: {
                                                      border: "none",
                                                    },
                                                  }}
                                                  value={
                                                    eachGas.filter(
                                                      (eG: any) => eG.selected
                                                    )[0]?.value
                                                  }
                                                  onChange={(e) =>
                                                    handleTableChange(
                                                      e,
                                                      "gasEmissionFactor",
                                                      mainIndex,
                                                      id,
                                                      eachGas,
                                                      eachUom.filter(
                                                        (each: any) =>
                                                          each.selected
                                                      )[0]
                                                    )
                                                  }
                                                />
                                              </TableCell>
                                              <TableCell
                                                sx={{
                                                  // width: "15rem !important",
                                                  paddingLeft:
                                                    "1rem !important",
                                                }}
                                              >
                                                {`${
                                                  eachGas.filter(
                                                    (eachG: any) =>
                                                      eachG.selected
                                                  )[0].name
                                                }/${eachUom[0].uomName}`}
                                              </TableCell>
                                              <TableCell
                                                sx={{
                                                  border: "1px solid #eaeef4",
                                                }}
                                              ></TableCell>
                                            </TableRow>
                                          );
                                        }
                                      )}
                                  </>
                                ) : (
                                  <TableRow sx={{ display: "flex" }}>
                                    <TableCell
                                      sx={{
                                        borderRight: "1px solid  #eaeef4",
                                      }}
                                    >
                                      <TextField
                                        sx={{ input: { textAlign: "right" } }}
                                        className="pw-textfiled-emission"
                                        inputProps={{
                                          style: {
                                            border: "none",
                                          },
                                        }}
                                        value={
                                          eachUom.filter(
                                            (eF: any) => eF.selected
                                          )[0]?.value
                                        }
                                        onChange={(e) =>
                                          handleTableChange(
                                            e,
                                            "emissionFactor",
                                            mainIndex,
                                            index,
                                            {},
                                            ""
                                          )
                                        }
                                      />
                                    </TableCell>
                                    <TableCell
                                      sx={{
                                        border: "1px solid  #eaeef4",
                                        width: "12rem",
                                      }}
                                    >
                                      <AntSelect
                                        suffixIcon={
                                          <CaretDownOutlined className="!pointer-events-none" />
                                        }
                                        className="pw-uom-selection pw-factoruom-selection"
                                        defaultValue={eachUom[0]?.name}
                                        value={
                                          eachUom.filter(
                                            (eF: any) => eF.selected
                                          )[0]?.name
                                        }
                                        onChange={(e) => {
                                          handleTableChange(
                                            e,
                                            "factorUom",
                                            mainIndex,
                                            index,
                                            {},
                                            ""
                                          );
                                        }}
                                      >
                                        {eachUom.map(
                                          (eachU: any, subId: number) => {
                                            return (
                                              <Option
                                                value={eachU.name}
                                                key={subId}
                                                className="pw-menu-item"
                                              >
                                                {eachU.name}
                                              </Option>
                                            );
                                          }
                                        )}
                                      </AntSelect>
                                    </TableCell>
                                    <TableCell
                                      sx={{
                                        borderRight: "1px solid  #eaeef4",
                                        marginTop: "1rem",
                                      }}
                                    >
                                      {
                                        <MoreVertIcon
                                          className="text-neutral-400 pw-ativity-icon"
                                          onClick={(e: any) => {
                                            handleClick(e, mainIndex, index);
                                          }}
                                        />
                                      }
                                      {
                                        <Menu
                                          anchorEl={anchorEl}
                                          open={open}
                                          onClose={() => handleClose("empty")}
                                        >
                                          <MenuItem
                                            key={id}
                                            onClick={(e) =>
                                              handleClose("Individual Gases")
                                            }
                                            className="pw-e2e-userprofile pw-menu-item"
                                          >
                                            {"Individual Gases"}
                                          </MenuItem>
                                        </Menu>
                                      }
                                    </TableCell>
                                  </TableRow>
                                );
                              }
                            )}
                          </TableCell>

                          {/* <TableCell sx={{ border: "1px solid  #eaeef4" }}>
                            {eachRow.factorUom.map(
                              (eachFactor: any, index: number) => {
                                return (
                                  <TableRow
                                    style={{ height: "3.55rem" }}
                                    className="flex flex-col items-center"
                                  >
                                    <TableCell>
                                      {
                                        <MoreVertIcon
                                          className="text-neutral-400 pw-ativity-icon"
                                          onClick={(e: any) => {
                                            handleClick(e, mainIndex, index);
                                          }}
                                        />
                                      }
                                      {eachFactor[0].gasesSelected ? (
                                        <Menu
                                          anchorEl={anchorE2}
                                          open={open2}
                                          onClose={() => handleClose("empty")}
                                        >
                                          <MenuItem
                                            key={id}
                                            onClick={(e) =>
                                              handleClose("KgCO2e")
                                            }
                                            className="pw-e2e-userprofile pw-menu-item"
                                          >
                                            {"Kg CO2e"}
                                          </MenuItem>
                                          <MenuItem
                                            key={id}
                                            onClick={(e) =>
                                              handleClose("tCO2e")
                                            }
                                            className="pw-e2e-userprofile pw-menu-item"
                                          >
                                            {"t CO2e"}
                                          </MenuItem>
                                        </Menu>
                                      ) : (
                                        <Menu
                                          anchorEl={anchorEl}
                                          open={open}
                                          onClose={() => handleClose("empty")}
                                        >
                                          <MenuItem
                                            key={id}
                                            onClick={(e) =>
                                              handleClose("Individual Gases")
                                            }
                                            className="pw-e2e-userprofile pw-menu-item"
                                          >
                                            {"Individual Gases"}
                                          </MenuItem>
                                        </Menu>
                                      )}
                                    </TableCell>
                                  </TableRow>
                                );
                              }
                            )}
                          </TableCell> */}

                          <TableCell sx={{ borderRight: "1px solid  #eaeef4" }}>
                            <div
                              className="flex justify-around "
                              onClick={() => {
                                handleDelete(mainIndex);
                              }}
                            >
                              <img
                                src="assets/icons/trash-can-outline.svg"
                                className="text-sm text-neutral-500"
                              />
                            </div>
                          </TableCell>
                        </TableRow>
                      );
                    })}
                  </TableBody>
                </Table>
              </div>
            ) : (
              ""
            )}
            <div
              className={`flex felx-row w-48 items-center gap-2 ${
                errorData.activityTypeError
                  ? "text-black text-neutral-300"
                  : "cursor-pointer text-primary"
              }`}
              onClick={() => {
                !errorData.activityTypeError && handleAddRow();
              }}
            >
              <AddIcon />
              <p>{t("Add row")}</p>
            </div>
          </div>
        </div>
      </div>
      <div className="flex flex-row justify-end pw-bunit-footer w-full gap-6">
        <div
          className="pw-bunit-button-light pw-bunit-button-next text-neutral bg-white font-bold"
          onClick={handleCancel}
        >
          {t("Cancel")}
        </div>
        <button
          className={`pw-bunit-button-primary pw-bunit-button-next text-white  pw-e2e-savebtn font-bold ${
            isValidForm()
              ? isLoading
                ? "text-black bg-neutral-300"
                : "cursor-pointer bg-primary"
              : "text-black bg-neutral-300"
          }`}
          onClick={() => isValidForm() && !isLoading && handleSave()}
          disabled={!isValidForm()}
        >
          {isLoading ? (
            <div className="flex flex-row gap-2 p-2">
              <span>{t("Saving up")}</span>
              <CircularProgress size={20} />
            </div>
          ) : (
            <span>{t("Save")}</span>
          )}
        </button>
      </div>
    </Fragment>
  );
};

export default CustomEmissionCreation;
